import React from 'react'

// prettier-ignore
export const StorageListingPage   = React.lazy(() => import('./pages[Storage]/ListingPage'))
// prettier-ignore
export const StorageDashboardPage = React.lazy(() => import('./pages[Storage]/DashboardPage'))
// prettier-ignore
export const StorageSupplyPage    = React.lazy(() => import('./pages[Transaction]/SupplyPage'))
// prettier-ignore
export const StorageTransferPage  = React.lazy(() => import('./pages[Transaction]/TransferPage'))
// prettier-ignore
export const StorageCheckinPage   = React.lazy(() => import('./pages[Transaction]/CheckInPage'))
// prettier-ignore
export const StorageCheckoutPage  = React.lazy(() => import('./pages[Transaction]/CheckOutPage'))
